import { TRANSFORM_TYPE_FIT } from './constants';
import { min } from 'lodash';
var blurParam = function (blur) { return (blur > 0 ? "blur_".concat(blur, ",") : ''); };
export var getImageFilename = function (pathname) {
    return pathname ? pathname.replace(/^media\//, '') : '';
};
export var getImageUrl = function (imageHost) {
    return function (_a, _b) {
        var _c = _a === void 0 ? { width: 1000, height: 1000 } : _a, fileName = _c.file_name, actualWidth = _c.width, actualHeight = _c.height;
        var _d = _b === void 0 ? {} : _b, _e = _d.maxWidth, maxWidth = _e === void 0 ? 1000 : _e, _f = _d.maxHeight, maxHeight = _f === void 0 ? 1000 : _f, _g = _d.quality, quality = _g === void 0 ? 80 : _g, _h = _d.type, type = _h === void 0 ? TRANSFORM_TYPE_FIT : _h, _j = _d.format, format = _j === void 0 ? 'png' : _j, _k = _d.blur, blur = _k === void 0 ? 0 : _k;
        if (fileName) {
            var _l = [min([maxWidth, actualWidth]), min([maxHeight, actualHeight])], width = _l[0], height = _l[1];
            return "https://".concat(imageHost, "/media/").concat(fileName, "/v1/").concat(type, "/w_").concat(width, ",h_").concat(height, ",").concat(blurParam(blur), "al_c,q_").concat(quality, "/file.").concat(format);
        }
        return '';
    };
};
//# sourceMappingURL=image.js.map